<template>
  <slot v-if="hidden" />
  <section v-else class="FilterDrawerSection" :aria-labelledby="headingId">
    <h3 :id="headingId" class="FilterDrawerSection-title">
      {{ title }}
    </h3>

    <slot />
  </section>
</template>

<script setup lang="ts">
import { useId } from 'vue';

defineProps<{
  title: string;
  hidden?: boolean;
}>();

const headingId = useId();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .FilterDrawerSection {
    &-title {
      @include text.text('md', vars.$typography-weight-strong);
      color: vars.$organisms-drawer-section-title-color;
      margin-bottom: vars.$dimensions-d-3;
    }
  }
}
</style>
